import type { Artwork, RecognizerEvent } from '../types';
import type { AudioPlayer } from './player';

/** recognizer のイベントを再生方針に変換する。continuous は lost を無視する。 */
export class AudioPolicy {
  constructor(
    private readonly player: AudioPlayer,
    private readonly artworks: Artwork[],
    private readonly mode: 'continuous' | 'follow',
    private readonly log: (m: string) => void,
  ) {}

  async handle(ev: RecognizerEvent): Promise<void> {
    if (ev.type === 'recognized') {
      const a = this.artworks.find((x) => x.id === ev.cls);
      if (!a) { this.log(`no artwork for class ${ev.cls}`); return; }
      if (this.player.current?.id === a.id && this.player.state === 'playing') return;
      await this.player.play(a);
      return;
    }
    if (ev.type === 'lost' && this.mode === 'follow') await this.player.stop();
  }
}
